/**
 * Canonical compliance mode for the app. Resolved once from GrowthBook flags
 * (see resolveComplianceLevel); features read capabilities off the matching
 * profile instead of reading flags directly. Add a new level here (e.g. V3)
 * plus a resolver branch and a registry row — consumers do not change.
 */
export enum ComplianceLevel {
  LEGACY = 'legacy',
  V1 = 'v1',
  V2 = 'v2',
}
